import { AUTH_ROOT } from 'env'
import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import { useAuth } from 'lib/auth'

const SignInNudge = () => {
  const { isLoggedIn } = useAuth()

  if (isLoggedIn) {
    return null
  }

  const loginUrl = `${AUTH_ROOT}?return_to=${encodeURIComponent(
    window.location.href,
  )}`

  return (
    <Box color="text.secondary" mb={1}>
      <Typography variant="caption">
        <Box display="inline" fontWeight={700}>
          <Link href={loginUrl}>Login</Link>
        </Box>
        &nbsp;or&nbsp;
        <Box display="inline" fontWeight={700}>
          <Link href={loginUrl}>Create</Link>
        </Box>
        &nbsp;a MyPGA account for a faster registration experience
      </Typography>
    </Box>
  )
}

export default SignInNudge
